import { render, staticRenderFns } from "./PDFPage.vue?vue&type=template&id=52f9a49a&lang=pug"
import script from "./PDFPage.vue?vue&type=script&lang=js"
export * from "./PDFPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./PDFPage.vue?vue&type=custom&index=0&blockType=docs&lang=md"
if (typeof block0 === 'function') block0(component)

export default component.exports